import React, { useEffect, useState } from 'react';
import { List } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import './mask-panel.less';
import useListTrack from '@/hooks/use-list-track';

interface IMaskListProps {
    /**
     *
     * 点击事件回调
     */
    handler: Function;

    /**
     *  显示还是隐藏
     */
    isShow?: boolean;

    /**
     *
     * 选中的mask的url
     */
    activeLayerMaskUrl?: string;

    /**
     *
     * 设置项的样式
     */
    itemStyle?: React.CSSProperties;

    /**
     *
     * 获取蒙版列表方法
     */
    getList: Function;

    /**
     * 埋点回调
     */
    trackCallback?: Function;
}
interface IImageMaskListProps<T> extends IMaskListProps {}

const firstIcon = {
    material: {},
    id: 10000,
    url: '',
    previewUrl: '',
    corner_mark_url: '',
};

const ImageMaskList: React.FC<IImageMaskListProps<any>> = <T,>(props) => {
    const { isShow = true, handler, activeLayerMaskUrl, itemStyle = {}, getList, trackCallback } = props;
    const [loading, setLoading] = useState<boolean>(true);
    const [cursor, setCursor] = useState<string | null | undefined>(null);
    const [maskList, setMaskList] = useState<T[]>([firstIcon as any as T]);

    const fetchList = async () => {
        if (cursor === '') return;
        setLoading(true);

        const { list, currentCursor } = await getList(cursor);

        setMaskList(maskList.concat(list));
        setCursor(currentCursor);
        setLoading(false);
    };
    useEffect(() => {
        fetchList();
    }, []);

    if (!isShow) return null;

    const renderImg = (data: T) => {
        const { url, threshold, corner_mark_url, previewUrl } = data as any;
        return (
            <>
                {/* 蒙版图片 */}
                {previewUrl ? <img className="m-mask-list__img" src={previewUrl} alt="" /> : null}

                {/* 提前加载svg,加快蒙版替换速度 */}
                {url ? <img className="m-mask-list__svg" src={url} alt="" /> : null}

                {/* 角标 */}
                {corner_mark_url ? (
                    <img className="m-mask-list__icon" src={corner_mark_url} alt="" width={26} height={14} />
                ) : null}
            </>
        );
    };
    const renderCleanIcon = () => {
        return <IconFont fontSize={45} name="SlashCircleBold" />;
    };

    useListTrack('maskCollapseList', maskList, (data: any) => {
        trackCallback && trackCallback(data);
    });

    return (
        <List<T>
            id="maskCollapseList"
            bodyClassName="m-mask-list"
            loading={loading}
            noMoreText=""
            hasMore={false}
            dataSource={maskList}
            nextPageRequest={fetchList}
            renderItem={(data) => {
                const { id, url, category, type_id, threshold = '0' } = data as any;
                const isCleanIcon = url === '';
                return (
                    <li
                        key={id}
                        data-type="track"
                        data-track-id={id}
                        data-track-category={category}
                        data-track-type={type_id}
                        data-track-vip={threshold}
                        onClick={() => {
                            if (isCleanIcon) {
                                handler && handler({ url: '', materialId: '', type_id: '', threshold });
                            } else {
                                handler && handler({ url, materialId: id, type_id, threshold });
                            }
                        }}
                        className={`
                        ${isCleanIcon ? 'clean-item' : ''}
                        ${activeLayerMaskUrl === url ? 'active' : ''}`}
                        style={itemStyle}
                    >
                        {isCleanIcon ? renderCleanIcon() : renderImg(data)}
                    </li>
                );
            }}
        />
    );
};

export default ImageMaskList;
